module.exports = __webpack_public_path__ + "media/images/basic_logos/qr_demo_image-43bd3731e64650391e8d0466fa85b92c.svg";